module.exports = __webpack_public_path__ + "962a1bf31c081691065fe333d9fa8105.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/semantic-ui-css/themes/default/assets/fonts/icons.svg
// module id = 253
// module chunks = 4